<script setup lang="ts">
import { FeatureType, useFeaturesStore } from "@/stores/features";

const props = defineProps<{
	feature: FeatureType;
}>();

const featureStore = useFeaturesStore();

const hasAccess = computed(() => {
	return featureStore.hasFeature(props.feature);
});
</script>

<template>
	<slot v-if="hasAccess" />
	<slot v-else name="fallback" />
</template>
